module.exports = __webpack_public_path__ + "static/media/Dried_and_smoked_fish_export_5.f70da9cb.jpg";